import dayjs from "dayjs";

export const tipoMonedas = [
  { value: "1", label: "L. Lempiras" },
  { value: "2", label: "$. Dólares" },
];

// Array of months, with names and corresponding month numbers
export const availableMonths = [
  { value: 1, label: "Enero" },
  { value: 2, label: "Febrero" },
  { value: 3, label: "Marzo" },
  { value: 4, label: "Abril" },
  { value: 5, label: "Mayo" },
  { value: 6, label: "Junio" },
  { value: 7, label: "Julio" },
  { value: 8, label: "Agosto" },
  { value: 9, label: "Septiembre" },
  { value: 10, label: "Octubre" },
  { value: 11, label: "Noviembre" },
  { value: 12, label: "Diciembre" },
];

// Get the current year
const currentYear = dayjs().year();

// Generate an array of the last four years, including the current year
export const availableYears = [
  { value: `${currentYear}`, label: `${currentYear}` },
  { value: `${currentYear - 1}`, label: `${currentYear - 1}` },
  { value: `${currentYear - 2}`, label: `${currentYear - 2}` },
  { value: `${currentYear - 3}`, label: `${currentYear - 3}` },
];

export const avisoCobroValues = {
  numeroAviso: 121745,
  codigoOperador: "AC0002",
  nombreOperador: "INTERNATIONAL MARITIME RADIO ACCOUNTIN CORP. S. DE R.L.",
  fechaEmision: "2024-10-21",
  fechaVencimiento: "2024-12-21",
  moneda: "L. Lempiras",
  servicio: "Servicio Internet o Acceso a Redes Informáticas",
  detalles: [
    {
      codigoConceptoCobro: "CC-20",
      concepto: "Recargo por Mora (Tarifa por Servicios de Supervisión)",
      descripcion: "Mora",
      valor: 50,
    },
    {
      codigoConceptoCobro: "CC-06",
      concepto: "Tarifa por Servicios de Supervision",
      descripcion: "Servicio",
      valor: 200,
    },
  ],
  total: 474.52, // Total calculado de los valores
};
